export const RatesTool: React.FC<{}> = () => {
  return <div>RATES TOOL! HEEEEEEERE WE GO DUDE</div>;
};
